import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ProjectsListSkeleton } from "@/app/projects/components/projects-list-skeleton";
import { ProjectsList } from "@/app/projects/list";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";
import { prefetchDashboardProjectsForOrg } from "@/lib/org-project-context/hooks";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/projects"
)({
  async beforeLoad(ctx) {
    await prefetchDashboardProjectsForOrg(
      ctx.context.queryClient,
      ctx.params.organizationId
    );
  },
  loader: () => ({
    crumb: "Projects",
  }),
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<ProjectsListSkeleton />}>
      <ProjectsList />
    </Suspense>
  ),
});
